module.exports = __webpack_public_path__ + "static/media/sylviebook1.77f7ff18.png";